import { useCallback } from 'react';

export const useLocalStorage = () => {

	// useCallback: identidad estable. Sin esto, AuthProvider (authContext.jsx) usa
	// getItem en los deps de su useEffect y, como la función se recreaba en cada
	// render, checkAuthenticated corría cada render y re-hidrataba la sesión: un
	// verify en vuelo durante el logout podía volver a escribir el token y la
	// sesión nunca se cerraba.
	const setItem = useCallback((key: string, value: string) => {
		localStorage.setItem(key, value);
	}, []);

	const getItem = useCallback((key: string) => {
		return localStorage.getItem(key);
	}, []);

	const removeItem = useCallback((key: string) => {
		localStorage.removeItem(key);
	}, []);
	
	return { setItem, getItem, removeItem };
};